// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e587ef5f","667":"6102a588"}[chunkId] + ".chunk.js";
};